import React from "react";

export const Tab = ({ children, active, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`py-3.5
      ${
        active
          ? "text-secondary font-semibold before:content-[' '] before:w-full before:h-[3px] before:bg-red-500 before:absolute relative before:-bottom-0"
          : "text-gray font-medium"
      }
      `}>
      {children}
    </button>
  );
};
